// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCxJtfYd0mF45HQiqMuL-YROvMyFrTzkCI",
  authDomain: "touch-world-ben.firebaseapp.com",
  databaseURL: "https://touch-world-ben.firebaseio.com",
  projectId: "touch-world-ben",
  storageBucket: "touch-world-ben.appspot.com",
  messagingSenderId: "304456811460",
  appId: "1:304456811460:web:36c62ee07234e0175d5a91",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const auth = firebase.auth();

export { db, auth }